import {getDocumentName} from '../../../utils/document';
import {pathHelpContentFile} from '../../../utils/path';
import {CONTENT_TYPE_INTERNAL_LINK, CONTENT_TYPE_TEXT, CONTENT_CATEGORY_MODEL} from '../../constants';

const DOCUMENT_PATH = `${pathHelpContentFile}fr/FR_MOD_DELEG/${getDocumentName('Délégation de pouvoirs Once For All')}.docx`;

export default {
  id: 'MOD_DELEG',
  title: 'Un modèle de Délégation de pouvoirs ?',
  description: '',
  categories: [CONTENT_CATEGORY_MODEL],
  contents: [{
    type: CONTENT_TYPE_TEXT,
    value: 'Si vous souhaitez mettre à jour la permission de signature, veuillez prendre le modèle suivant :'
  },
  {
    type: CONTENT_TYPE_INTERNAL_LINK,
    value: DOCUMENT_PATH,
    label: 'Délégation de pouvoirs.'
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: 'Renvoyez le document complété et signé avec votre pièce d’identité à service.clients@onceforall.com.'
  }]
};
